import {Tag, TagColor, TagSize} from '@benchling/nucleus-ui';
import React from 'react';

import {ExtensionType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {EXTENSION_TYPE_LABELS, tagColorForRegistryLabel, type RegistryLabel} from './extensionConstants';

/** Nucleus tags for registry label rows — shows each row's value display name (GraphQL ``displayName``). */
export function RegistryLabelBadges({
  labels,
}: {
  labels: ReadonlyArray<Pick<RegistryLabel, 'displayName' | 'key' | 'value'>>;
}): JSX.Element | null {
  if (labels.length === 0) {
    return null;
  }
  return (
    <>
      {labels.map((lab) => (
        <Tag
          key={`${lab.key}:${lab.value}`}
          text={lab.displayName}
          size={TagSize.SMALL}
          color={tagColorForRegistryLabel(lab)}
        />
      ))}
    </>
  );
}

interface ExtensionTagsProps {
  extensionType: ExtensionType;
  registryLabels?: ReadonlyArray<RegistryLabel> | null;
}

export default function ExtensionTags({extensionType, registryLabels}: ExtensionTagsProps): JSX.Element {
  return (
    <>
      <Tag text={EXTENSION_TYPE_LABELS[extensionType]} size={TagSize.SMALL} color={TagColor.SECONDARY} />
      <RegistryLabelBadges labels={registryLabels ?? []} />
    </>
  );
}
